/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */
// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;
export default [[["da noite", "da madrugada", "da mañá", "do mediodía", "da tarde", "da noite"], u, u], [["medianoite", "madrugada", "mañá", "mediodía", "tarde", "noite"], u, u], ["00:00", ["00:00", "06:00"], ["06:00", "12:00"], ["12:00", "13:00"], ["13:00", "21:00"], ["21:00", "24:00"]]];
